import { createKvSyncModule, updateFeatureFlagsPlugin } from '@ahaslides-product/frontend-toolkit'
import { getKvSyncApi } from '@/api/kvSync.js'
import kvSyncSubscriber from '@/mqtt/kvSync'
import Sentry from '@/3rd-parties/sentry'

export default {
  ...createKvSyncModule({
    getKvSyncApi,
    kvSyncMqttSubscriber: kvSyncSubscriber,
    captureException: Sentry.captureException,
  }),
  plugins: [
    updateFeatureFlagsPlugin,
  ],
}
